import { isNumber } from 'util';

export const ADD_FILE = 'add_file';
export const REMOVE_FILE = 'remove_file';

export type FileType = {
  name: string;
  base64: object;
};

export const uploadFilesReducer = (
  state: {
    files: FileType[];
  },
  action: { index?: number; file?: FileType; type: string },
) => {
  switch (action.type) {
    case ADD_FILE: {
      if (!action.file) {
        throw new Error();
      }

      return {
        files: [...state.files, action.file],
      };
    }
    case REMOVE_FILE: {
      if (!isNumber(action.index)) {
        throw new Error();
      }

      const array = state.files;
      state.files.splice(action.index, 1);

      return {
        files: array,
      };
    }

    default:
      throw new Error();
  }
};
